var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5"},[_c('CommonExpansionPanel',{scopedSlots:_vm._u([{key:"title-panel",fn:function(){return [_vm._v(" Seguimiento ")]},proxy:true}])},[(_vm.tabReplace == 1)?_c('ViewEmailInfoCard',{attrs:{"cuentaData":_vm.cuentaData},on:{"changeTab":_vm.tabReplaceSelect}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }